import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useStyles } from './VirtualProductBadge.styles';
import type { ProductImageBadge } from  "utils/business/virtualproduct/express.product.types";

interface VirtualProductBadgeProps {
  virtualProductLabel?: string;
  hasBadge?: boolean;
  badge?: ProductImageBadge;
}

const VirtualProductBadge: React.FC<VirtualProductBadgeProps> = ({
  virtualProductLabel,
  hasBadge,
  badge,
}) => {
  const classes = useStyles();

  if (!virtualProductLabel && !hasBadge) {
    return null;
  }

  return (
    <Grid container direction="column" spacing={1}>
      {virtualProductLabel && (
        <Grid item>
          <Typography className={classes.virtualProductLabel}>
            {virtualProductLabel}
          </Typography>
        </Grid>
      )}
      {hasBadge && badge && (
        <Grid item>
          <span className={classes.badge}>
            {badge.label}
          </span>
        </Grid>
      )}
    </Grid>
  );
};

export default VirtualProductBadge;
